import formatData from "./formatData";
import loadLobs from "./loadLobs";
import { listCatalogServices } from "@common/hooks/serviceCatalog";

const loadStandardServices = async ({
  account_slug,
  authorizationCode,
  filters = {},
  pageSize,
  pageNumber,
  selectedIds = [],
  approved = false,
}) => {
  const { data, included, meta, error } = await listCatalogServices({
    accessToken: authorizationCode,
    approved,
    include: [
      "service-category",
      "phase",
      "subservices",
      "resource",
      "subservices.resource",
      "subservices.service",
    ],
    filter: {
      state: "active",
      exclude: selectedIds.join(","),
      ...(filters || {}),
    },
    page: { number: pageNumber, size: pageSize },
  });
  if (error) return { data: null, error };

  try {
    const lobs = await loadLobs({ account_slug, authorizationCode });
    return {
      data: formatData({ data, included: [...included, ...lobs.data] }),
      error: null,
      meta,
    };
  } catch (err) {
    return { data: null, error: err };
  }
};

export default loadStandardServices;
